import requestOld from '@/api/requestOld';

// 获取表单列表
export function getFormList(data) {
  return requestOld({
    url: '/api/customform/get',
    method: 'post',
    data
  })
}
// 提交表单
export function submitForm(data) {
  return requestOld({
    url: '/customForm/action',
    method: 'post',
    data
  })
}
// 获取表单
export function getForm(data) {
  return requestOld({
    url: '/customForm/get',
    method: 'post',
    data
  })
}
// 提交表单 数据安全月
export function submitFormData(data) {
  return requestOld({
    url: '/customForm/action',
    method: 'post',
    data
  })
}
// HK Premier 获取表单 banner
export function getFormBanner(params) {
  return requestOld({
    url: '/customForm/getBanner',
    method: 'get',
    params
  })
}